import __vue_component__ from '../../Tree/Tree.vue.js';

//
var script = {
  name: 'SelectMenu',
  components: {
    Tree: __vue_component__
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Array, Object],
      default: () => []
    },
    currentSuggestionId: {
      type: [String, Number],
      default: undefined
    },
    hasSuggestions: {
      type: Boolean,
      default: false
    },
    containsQuery: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    noOptionsMessage: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    search: {
      type: String,
      default: ''
    }
  },
  methods: {
    onOptionSelected(option, ancestors) {
      this.$emit('option-selected', option, ancestors);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/TreeSelect/SelectMenu.vue_rollup-plugin-vue=script.js